import React, { useRef, useEffect, useState } from 'react';
import './Home.css';
import { useSpring, animated } from '@react-spring/web';

const Home = () => {
  const [path, setPath] = useState('');
  const containerRef = useRef(null);

  const items = [
    { 
      title: 'Ver formación y realizar tests', 
      description: 'Es obligatorio sacar al menos un 7 para avanzar al siguiente módulo.' 
    },
    {
      title: 'Presentarse al examen teórico',
      description: 'Es necesario obtener más de 7 en el examen',
    },
    {
      title: 'Realizar llamadas de práctica',
      description: 'Hacer prácticas con Denise, experta en ventas',
    },
    {
      title: 'Llamada examen',
      description: 'Realiza una llamada final dónde se pondrá a prueba todo lo aprendido.',
    },
    {
      title: 'Acceso a la bolsa de trabajo',
      description: 'Se irán compartiendo propuestas y se habilitará la pestaña de Empresas dentro de la plataforma.',
    },
  ];

  useEffect(() => {
    const calculatePath = () => {
      if (containerRef.current) {
        const circles = containerRef.current.querySelectorAll('.circle');
        let pathD = `M ${circles[0].offsetLeft + circles[0].offsetWidth / 2} ${circles[0].offsetTop + circles[0].offsetHeight / 2 + 20}`;

        for (let i = 1; i < circles.length; i++) {
          const x = circles[i].offsetLeft + circles[i].offsetWidth / 2;
          const y = circles[i].offsetTop + circles[i].offsetHeight / 2 + 20;
          pathD += ` L ${x} ${y}`;
        }

        setPath(pathD);
      }
    };

    calculatePath();
    window.addEventListener('resize', calculatePath);
    return () => window.removeEventListener('resize', calculatePath);
  }, []);

  return (
    <>
      <div className="background-img">
      <div style={{  zIndex: 2 }}>Aprende la habilidad <span className="highlight"> más demandada </span> de los últimos tiempos</div>
      </div>
      <div className="timeline-container" ref={containerRef}>
        <svg className="timeline-svg" xmlns="http://www.w3.org/2000/svg">
          <path
            d={path}
            stroke="gold"
            fill="transparent"
            strokeWidth="2" />
        </svg>

        {items.map((item, index) => (
          <TimelineItem key={index} item={item} index={index} />
        ))}
      </div>
    </>
  );
};

const TimelineItem = ({ item, index }) => {
  const slideIn = useSpring({
    from: { opacity: 0, transform: `translateX(${index % 2 === 0 ? '-50%' : '50%'})` },
    to: { opacity: 1, transform: 'translateX(0)' },
    config: { tension: 120, friction: 20 },
    delay: index * 300, // Retraso más largo
  });

  return (
    <animated.div style={slideIn} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
      <div className="timeline-point">
        <div className="circle">{index + 1}</div>
      </div>
      <div className="timeline-content">
        <h2 className='item-title'>{item.title}</h2>
        <p>{item.description}</p>
      </div>
    </animated.div>
  );
};

export default Home;
